import React from 'react';

export default class Progress extends React.Component {
  render() {
    const {progress} = this.props;

    return <div style={{backgroundColor: 'lightgrey', borderRadius: '10px', height: '20px', position: 'relative'}}>
      <div style={{width: `${progress}%`, backgroundColor: '#367fa9', textAlign: 'center', borderRadius: '10px', height: '20px'}}/>
      <span style={{color: 'white',position: 'absolute', left: '50%', top: 0}}>{Math.floor(progress)}%</span>
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/Analysis/Data/Progress.js